// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__26P6U","title":"Info_title__vJSRj","selects":"Info_selects__2BENz","requiredAsterisk":"Info_requiredAsterisk__1l130"};